import React from "react";
import { Redirect } from 'react-router-dom';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Collapse,
  NavItem,
  NavLink
} from "shards-react";

export default class UserActions extends React.Component {
  constructor(props) {
    super(props);
    this.onClickLogout = this.onClickLogout.bind(this);
    this.state = {
      visible: false,
      redirect: false,
    };

    this.toggleUserActions = this.toggleUserActions.bind(this);
  }


  onClickLogout(e){
    e.preventDefault();
   console.log("onClickLogout")
    this.setState({
      redirect: true
    })
  }
  logoutRedirect= () => {
    if (this.state.redirect) {
      return <Redirect to='/logout' />
    }
  }

  toggleUserActions() {

    this.setState({
      visible: !this.state.visible
    });
  }

  getUserName() {
    let userName = localStorage.getItem("AdminName");
    if(userName){
      userName = userName.replace(/"/g, "");;
    }else{
      userName = "";
    }
    
    return userName
  }

  render() {
    return (
      <NavItem tag={Dropdown} caret toggle={this.toggleUserActions}>
        <DropdownToggle caret tag={NavLink} className="text-nowrap px-3">
          <img
            className="user-avatar rounded-circle mr-2"
            src={require("./../../../../images/tv-finder-images/no_user2.jpeg")}
            alt="User Avatar"
          />{" "}
          <span className="d-none d-md-inline-block" style={{cursor: "pointer"}}>{this.getUserName()}</span>
        </DropdownToggle>
        <Collapse tag={DropdownMenu} right small open={this.state.visible}>
        {this.logoutRedirect()}
          <DropdownItem   onClick={this.onClickLogout} className="text-danger">
            <i className="material-icons text-danger">&#xE879;</i> Logout
          </DropdownItem>
        </Collapse>
      </NavItem>
    );
  }
}
